import { all, setContext } from 'redux-saga/effects';

import { apolloClient } from '@api/client';

import { watchAuthSaga } from './auth/auth.saga';
import { watchUserSaga } from './user/user.saga';
import { watchAdministratorSaga } from './administrator/administrator.saga';
import { watchProfileSaga } from './profile/profile.saga';
import { watchAuthorSaga } from './entities/author/author.saga';
import { watchSerieSaga } from './entities/serie/serie.saga';
import { watchBookSaga } from './entities/book/book.saga';

export default function* RootSaga() {
  yield all([
    setContext({ apolloClient, store: {} }),
    watchAuthSaga(),
    watchUserSaga(),
    watchAdministratorSaga(),
    watchProfileSaga(),
    watchAuthorSaga(),
    watchSerieSaga(),
    watchBookSaga(),
  ]);
}
